import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { ListingFormValues } from "@/components/listings/filters/FilterSchema";

interface RoomsSectionProps {
  form: UseFormReturn<ListingFormValues>;
}

const RoomsSection = ({ form }: RoomsSectionProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <FormField
        control={form.control}
        name="rooms"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Rooms / Partitions</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 4"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="bathrooms"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Bathrooms</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 2"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="parkings"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Parking Spaces</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 4"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="floors"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Number of Floors</FormLabel>
            <FormControl>
              <Input
                type="number"
                placeholder="e.g., 2"
                {...field}
                value={field.value ?? ""}
                onChange={(e) =>
                  field.onChange(parseFloat(e.target.value) || undefined)
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default RoomsSection;
